export default __webpack_public_path__ + "static/media/Rahul_Singh_Resume.1fe33208.pdf";